
















































































import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport } from "@/models/report.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ClaimSettlementUpdateDialog from "./claim-settlement/ClaimSettlementUpdateDialog.vue";
import ClaimSettlementSendDialog from "./claim-settlement/ClaimSettlementSendDialog.vue";

@Component({
  components: {
    ClaimSettlementUpdateDialog,
    ClaimSettlementSendDialog,
    MTextField,
    MSelect,
    MIconButton
  }
})
export default class PartnerReportDetailClaimSettlement extends mixins(PermissionMixin) {
  @Prop() value!: IReport;

  readonly = true;

  isDialogOpen = false;
  isSendDialogOpen = false;

  edit() {
    this.isDialogOpen = true;
  }

  send() {
    this.isSendDialogOpen = true;
  }
}
